import { getApiBaseUrl } from "@/lib/api-base";
import { editorHeaders } from "@/lib/sacred-library/sacred-library-api";

const API = getApiBaseUrl();

async function request(path, options = {}) {
  const res = await fetch(`${API}${path}`, options);
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed: ${res.status}`);
  }
  return res.json();
}

export function fetchTownhallAdminDetail(chantId) {
  return request(`/townhall/admin/${encodeURIComponent(chantId)}`, {
    headers: editorHeaders(),
  });
}

export function saveTownhallAdminDetail(chantId, body) {
  return request(`/townhall/admin/${encodeURIComponent(chantId)}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...editorHeaders(),
    },
    body: JSON.stringify(body),
  });
}

export function uploadTownhallDeityImage(chantId, body) {
  return request(`/townhall/admin/${encodeURIComponent(chantId)}/image`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...editorHeaders(),
    },
    body: JSON.stringify(body),
  });
}

export function importTownhallSlokasFromUrl(chantId, body) {
  return request(`/townhall/admin/${encodeURIComponent(chantId)}/import`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...editorHeaders(),
    },
    body: JSON.stringify(body),
  });
}

